export const capitalize = (input: string) => {
    if (!input) {
        return input;
    }

    return `${input[0].toLocaleUpperCase()}${input.substring(1)}`;
};

export const getCountry = (countryCode: string) => (countryCode || '').substring(countryCode.length - 2).toLowerCase();
